export const posesData = [
  // ==========================================
  // BUSINESS (20)
  // ==========================================
  {
    id: "BIZ-001",
    subject: "Business",
    instruction: "I want you to stand tall in three-quarter profile; cross your arms softly, drop your shoulders, tuck the chin a hair, and give me a calm, confident gaze so the suit and jawline read strong without stiffness.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-001.jpg",
    insights: ["Watch for fabric bunching at the back of the neck when arms are crossed.", "Ensure the front hand isn't tucked too deep; show the fingers for a more relaxed look.", "Position the key light to create a shadow under the jawline for maximum definition."]
  },
  {
    id: "BIZ-002",
    subject: "Business",
    instruction: "I want you to sit at the edge of the chair, lean slightly forward with one forearm on your knee and the other hand relaxed, keep your spine long and offer a small, engaged smile so the frame reads approachable and grounded.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-002.jpg",
    insights: ["Leaning forward creates immediate rapport and reduces perceived distance.", "Shoot from slightly above eye level to emphasize the 'engaged' connection.", "Check that the back isn't slumping; keep the chest lifted."]
  },
  {
    id: "BIZ-003",
    subject: "Business",
    instruction: "I want you to turn a hair away from me and adjust your tie with one hand; keep the opposite shoulder relaxed, lower your chin slightly, and hold a purposeful, composed look while I lock the tie line and cheek contour.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-003.jpg",
    insights: ["The 'action' of adjusting a tie adds a dynamic, candid feel to corporate portraits.", "Focus the lighting on the side of the face closest to the camera.", "Ensure the hand is relaxed; tight fingers show unnecessary tension."]
  },
  {
    id: "BIZ-004",
    subject: "Business",
    instruction: "I want you to sit square to the camera with hands lightly folded on the table, shoulders even and spine long; hold a calm, open expression and angle your torso a touch toward me for depth.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-004.jpg",
    insights: ["Even shoulders can look 'boxy'; a slight torso angle adds dimension.", "Keep hands visible to project transparency and trustworthiness.", "Use a shallow depth of field to keep the focus strictly on the eyes."]
  },
  {
    id: "BIZ-005",
    subject: "Business",
    instruction: "I want you to step forward as if to offer a handshake—extend your right hand a fraction, palm relaxed, shoulders back, and give a warm, inviting nod or smile so the gesture reads confident and welcoming.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-005.jpg",
    insights: ["The forward movement creates a sense of leadership and proactivity.", "Watch the hand position; it should be inviting, not blocking the body.", "Capture the frame mid-gesture for the most natural energy."]
  },
  {
    id: "BIZ-006",
    subject: "Business",
    instruction: "I want you to stand with hands on hips, weight shifted to one leg; relax your jaw and shoulders, keep the stance assertive but not rigid, and hold steady for a commanding frame.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-006.jpg",
    insights: ["Shifting weight to one leg creates a more natural silhouette.", "Keep the elbows slightly back to open up the chest area.", "A lower camera angle increases the subject's perceived authority."]
  },
  {
    id: "BIZ-007",
    subject: "Business",
    instruction: "I want you to walk toward me with a purposeful, even stride and a briefcase in hand; keep your shoulders relaxed, eyes forward, and take long steps so movement reads decisive and composed.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-007.jpg",
    insights: ["Use a fast shutter speed (1/500+) to freeze the motion cleanly.", "Encourage a 'heel-to-toe' walk for a smoother, less bouncy stride.", "The briefcase should be on the side further from the camera."]
  },
  {
    id: "BIZ-008",
    subject: "Business",
    instruction: "I want you to stand center-frame and lift both hands slightly with palms open; soften your smile, lower the shoulders, and present a genuine, candid energy to the lens.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-008.jpg",
    insights: ["Open palms signify vulnerability and trust.", "Keep the elbows close to the ribs to keep the silhouette compact.", "Wait for the smile to reach the eyes before triggering the shutter."]
  },
  {
    id: "BIZ-009",
    subject: "Business",
    instruction: "I want you to put your hands in your pockets with thumbs out and shift weight to one hip; keep the shoulders loose and offer a relaxed, confident look so the silhouette stays clean against the wall.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-009.jpg",
    insights: ["Thumbs out prevents the hands from looking like they disappeared.", "The wall provides a 'third leg' of support for a more relaxed lean.", "Check that the jacket isn't riding up too high at the waist."]
  },
  {
    id: "BIZ-010",
    subject: "Business",
    instruction: "I want you to sit upright with hands clasped on the table, lean in a touch, and hold a calm, intent expression so the portrait reads focused and professional.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-010.jpg",
    insights: ["Clasped hands create a strong anchor point for the lower frame.", "Watch the neck; ensure the chin is slightly extended to sharpen the jawline.", "Soft side-lighting works best to avoid harsh shadows under the hands."]
  },
  {
    id: "BIZ-011",
    subject: "Business",
    instruction: "I want you to lean forward with elbows on your knees and hands clasped; tilt your head up a fraction and hold a steady, thoughtful gaze that conveys seriousness without tension.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-011.jpg",
    insights: ["This 'thinker' variant is powerful for tech and creative leadership.", "Keep the background dark or minimal to keep focus on the expression.", "Check that the shoulders aren't bunching up toward the ears."]
  },
  {
    id: "BIZ-012",
    subject: "Business",
    instruction: "I want you to lean in toward me slightly, keep hands softly clasped on the table, and present a composed, attentive expression—small movements only so the frame stays crisp and authoritative.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-012.jpg",
    insights: ["Attentive leaning signals a 'listener' persona.", "Watch for glare on eyewear; adjust the light angle if necessary.", "Maintain a narrow aperture (f/5.6) to keep hands and face sharp."]
  },
  {
    id: "BIZ-013",
    subject: "Business",
    instruction: "I want you to adjust your tie or lapel with one hand, keep the other hand relaxed at your side, square your shoulders, lower the chin slightly, and give me a measured, confident look into the lens.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-013.jpg",
    insights: ["The hand at the lapel creates a leading line toward the face.", "Ensure the square shoulders don't lead to a 'boxy' look.", "Ask for a 'smize' (smiling with eyes) to add warmth."]
  },
  {
    id: "BIZ-014",
    subject: "Business",
    instruction: "I want you to sit with a warm, controlled smile and hands relaxed on the table; angle your torso a touch toward me to read open and approachable while keeping the background simple.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-014.jpg",
    insights: ["A simple background prevents the viewer's eye from wandering.", "Hands should be spread slightly to look grounded.", "Use a fill-light to soften any heavy shadows on the far side of the face."]
  },
  {
    id: "BIZ-015",
    subject: "Business",
    instruction: "I want you to stand with arms crossed but softened; tilt the chin up a fraction, relax the shoulders, and hold a steady, professional expression that reads quiet confidence.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-015.jpg",
    insights: ["A slight chin lift suggests vision and foresight.", "Softened arms mean not tucking hands away; show the fingers.", "Keep the camera at chest level to balance authority and friendliness."]
  },
  {
    id: "BIZ-016",
    subject: "Business",
    instruction: "I want you to sit at the desk and make a small, deliberate gesture with your pen while writing; keep your head angled toward the page, shoulders relaxed, and face focused to convey intentional work in progress.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-016.jpg",
    insights: ["The pen acts as a prop that anchors the 'working' narrative.", "Ensure the face isn't too shadowed when the subject looks down.", "Capture the shot mid-stroke for the most authentic movement."]
  },
  {
    id: "BIZ-017",
    subject: "Business",
    instruction: "I want you to sit centered with hands visible and loosely clasped in front; lean in a touch, offer a genuine, relaxed smile, and let the portrait feel personable and professional.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-017.jpg",
    insights: ["Centered composition works well for 'About Us' pages.", "Loose clasping prevents defensive body language.", "Warm the white balance slightly to enhance friendliness."]
  },
  {
    id: "BIZ-018",
    subject: "Business",
    instruction: "I want you to walk past me with measured steps and your shoulder bag on; look ahead with calm focus, keep shoulders down, and let the motion stay steady so I can capture purposeful movement.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-018.jpg",
    insights: ["The shoulder bag adds an 'on-the-go' lifestyle element.", "Encourage a steady gaze to avoid a wandering look.", "Shoot from a slightly lower angle to make the stride look heroic."]
  },
  {
    id: "BIZ-019",
    subject: "Business",
    instruction: "I want you to sit forward at the desk with the notebook visible, turn your head slightly toward me, and use small hand movements to show engagement while maintaining a composed presence.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-019.jpg",
    insights: ["The notebook provides a clean foreground element to frame the subject.", "Hand gestures should be kept below the chin level.", "Focus lighting on the face, letting the desk fall into soft shadow."]
  },
  {
    id: "BIZ-020",
    subject: "Business",
    instruction: "I want you to sit with the paper and pen, angle your body toward the page, and hold a focused, deliberate expression—I'll time the shutter on a natural pause to show concentration.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BIZ-020.jpg",
    insights: ["The 'natural pause' is usually right after finishing a sentence.", "Check the angle of the pen so it doesn't create a distracting highlight.", "A side-profile-heavy angle emphasizes the focus and work ethic."]
  },

  // ==========================================
  // SENIOR (20)
  // ==========================================
  {
    id: "SEN-001",
    subject: "Senior",
    instruction: "I want you to face me square, relax your jaw, drop your shoulders a touch, and hold a calm, neutral expression while I tuck your hair back from the face so the portrait reads clean and direct.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-001.jpg",
    insights: ["Perfect posture is key; remind them to 'grow tall'.", "Hair tucked highlights cheekbones and the jawline.", "Use a wide aperture (f/1.8) for maximum eye impact."]
  },
  {
    id: "SEN-002",
    subject: "Senior",
    instruction: "I want you to sit on the grass with hands loosely clasped, breathe slowly, soften your shoulders, and hold a gentle, open gaze at the camera so the natural background feels effortless and relaxed.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-002.jpg",
    insights: ["Sitting on the ground creates a grounded energy.", "Watch for 'slumping'; keep the chest lifted.", "Golden hour light is essential for a soft, nostalgic feel."]
  },
  {
    id: "SEN-003",
    subject: "Senior",
    instruction: "I want you to give me that wink and a quick smile—tilt your head a fraction toward me, keep the expression playful, and hold it for a couple of frames so I can catch the candid spark.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-003.jpg",
    insights: ["The wink eye must be sharp; other eye stays open.", "Head tilt adds personality and fun.", "Use burst mode to capture the micro-moment smile."]
  },
  {
    id: "SEN-004",
    subject: "Senior",
    instruction: "I want you to lean your shoulder into the wall, look slightly downward and to the side, keep your face soft, and hold that quiet, introspective moment while I frame the minimal background.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-004.jpg",
    insights: ["Looking away creates an editorial, moody feel.", "The wall provides a vertical anchor line.", "Check that the leaning shoulder isn't bunched up."]
  },
  {
    id: "SEN-005",
    subject: "Senior",
    instruction: "I want you to sit on the steps, settle your hands in front, relax your shoulders, and lean into a small, natural smile so your posture reads calm and approachable.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-005.jpg",
    insights: ["Steps provide natural leading lines.", "Hands should be relaxed; avoid tight grips.", "Remind them to breathe deeply to settle the pose."]
  },
  {
    id: "SEN-006",
    subject: "Senior",
    instruction: "I want you to stand with hands on your hips, open your chest, smile genuinely and keep your shoulders down so the V-neck and waves read warm and confident.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-006.jpg",
    insights: ["Hands high on the waist helps elongate legs.", "Generate a laugh for an authentic smile.", "Check that hair waves are balanced on both sides."]
  },
  {
    id: "SEN-007",
    subject: "Senior",
    instruction: "I want you to walk slowly through the field with a soft, golden backlight—relax your arms, keep your spine long, and look toward the horizon so the moment feels serene and cinematic.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-007.jpg",
    insights: ["Backlighting creates a magical 'halo' effect.", "Longer strides make walking look more elegant.", "Looking away adds a storytelling element."]
  },
  {
    id: "SEN-008",
    subject: "Senior",
    instruction: "I want you to turn your head slightly left, keep your chin level, hold a soft, neutral expression, and let the warm light sculpt the edge of your profile.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-008.jpg",
    insights: ["Profile shots emphasize strong jawlines.", "Keep eyes 'active' by looking at a distant point.", "Watch for stray hairs breaking the profile line."]
  },
  {
    id: "SEN-009",
    subject: "Senior",
    instruction: "I want you to sit forward on the chair, lean on the backrest with your arms, smile into the lens and keep your shoulders relaxed so the pose reads friendly and candid.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-009.jpg",
    insights: ["Backrests provide a sense of security for subjects.", "Lean forward to emphasize the face over the body.", "Drop shoulders to avoid a 'hunched' appearance."]
  },
  {
    id: "SEN-010",
    subject: "Senior",
    instruction: "I want you to stand tall in the jacket with hands in pockets, keep your face neutral and composed, and hold that poised, fashion-forward energy for the frame.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-010.jpg",
    insights: ["Keep thumbs out of pockets for better hand shape.", "Maintain 'eye intensity' for neutral expressions.", "Check that the jacket collar sits flat."]
  },
  {
    id: "SEN-011",
    subject: "Senior",
    instruction: "I want you to lean on the railing, smile openly and look at the camera—keep your hands relaxed and your posture casual to amplify that approachable, outdoorsy vibe.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-011.jpg",
    insights: ["Railings act as natural anchors for arms.", "Ensure the lean is light to avoid looking heavy.", "Use the railing as a leading line to the subject."]
  },
  {
    id: "SEN-012",
    subject: "Senior",
    instruction: "I want you to stand square with arms crossed, hold your gaze steady and your shoulders down, and keep the expression confident and resolute so the silhouette reads strong.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-012.jpg",
    insights: ["Cross arms loosely to avoid looking angry.", "Tilt the chin down slightly for a stronger gaze.", "Check for sleeve bunching that distorts the arm shape."]
  },
  {
    id: "SEN-013",
    subject: "Senior",
    instruction: "I want you to sit cross-legged on the path, relax your hands on your knees, tilt your chin up slightly and laugh naturally when I cue you so the scene reads spontaneous and joyful.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-013.jpg",
    insights: ["Sitting on a path adds adventure narrative.", "Timing is everything; capture the peak of the laugh.", "Ensure the chin lift doesn't expose too much nostril."]
  },
  {
    id: "SEN-014",
    subject: "Senior",
    instruction: "I want you to sit on the path with hands clasped and a big smile—breathe into that laugh and hold it so I can capture an authentic, uplifted moment.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-014.jpg",
    insights: ["Clasped hands around knees look cozy.", "Ask them to think of a funny secret for real smiles.", "Shoot at eye level for an intimate feel."]
  },
  {
    id: "SEN-015",
    subject: "Senior",
    instruction: "I want you to place your hands in front of your face in that thoughtful pose, soften your eyes, and hold the contemplative energy while I tighten the frame on your expression.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-015.jpg",
    insights: ["Keep fingers soft and elegant near the face.", "Look just past the lens for a softer gaze.", "Focus on the eye closest to the camera."]
  },
  {
    id: "SEN-016",
    subject: "Senior",
    instruction: "I want you to walk with a relaxed stride, phone in hand, give me a broad smile and look up occasionally so the motion reads lively and candid.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-016.jpg",
    insights: ["The phone adds a modern, current-life element.", "Capture the 'look up' for the best engagement.", "Fast shutter speed (1/400+) keeps the stride sharp."]
  },
  {
    id: "SEN-017",
    subject: "Senior",
    instruction: "I want you to sit at the table holding the mug, lift it slightly toward your face and let a warm smile form—relax your shoulders and keep the scene cozy and intimate.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-017.jpg",
    insights: ["The mug warms up the subject's expression.", "Keep the mug below the jawline to show the face.", "Natural window light works best for this scene."]
  },
  {
    id: "SEN-018",
    subject: "Senior",
    instruction: "I want you to stand with the strap over your shoulder, take a casual step, and smile broadly while keeping your posture easy and natural so the candid city vibe comes through.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-018.jpg",
    insights: ["Bag straps create natural diagonal leading lines.", "Take small steps to maintain balance and focus.", "High-contrast city light adds an urban edge."]
  },
  {
    id: "SEN-019",
    subject: "Senior",
    instruction: "I want you to walk down the sidewalk carrying both paper bags, keep your shoulders relaxed and grin like you just found something great—swing the bags lightly for motion.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-019.jpg",
    insights: ["Bags act as a 'shopping' lifestyle prop.", "Light swinging adds rhythm to the walk.", "Wide smiles look best looking slightly off-camera."]
  },
  {
    id: "SEN-020",
    subject: "Senior",
    instruction: "I want you to sit on the outdoor steps, hold the phone with both hands, look down at it, then bring your gaze up and smile so the moment feels genuinely connected.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/SEN-020.jpg",
    insights: ["Transitioning gazes creates a mini-story.", "Watch for phone screen reflections in eyes.", "Keep the neck long to avoid a double chin."]
  },

  // ==========================================
  // COUPLE (20)
  // ==========================================
  {
    id: "CPL-001",
    subject: "Couple",
    instruction: "I want you to stand close with your foreheads touching; soften your faces, drop your shoulders, clasp hands gently between your chests, and breathe slowly so the sunset rim light sculpts your profiles into a warm, intimate silhouette.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-001.jpg",
    insights: ["Sync their breathing to settle the pose.", "Maintain a tiny gap between noses for profiles.", "Focus on the point where foreheads meet."]
  },
  {
    id: "CPL-002",
    subject: "Couple",
    instruction: "Walk slowly hand-in-hand through the field with relaxed strides; talk to each other and laugh a bit, and please take small lead steps so the fabric and sunlit grass read motion and connection.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-002.jpg",
    insights: ["Share a secret for authentic candid reactions.", "Small steps keep the frames unblurred.", "Low angle makes the grass feel immersive."]
  },
  {
    id: "CPL-003",
    subject: "Couple",
    instruction: "Sit close on the couch with your head resting on your partner's shoulder; close your eyes and relax while the other person keeps a soft, steady gaze so the frame reads comfort and quiet companionship.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-003.jpg",
    insights: ["The 'watcher' partner needs a soft loving gaze.", "Check for 'floating hands'; ensure they are resting.", "Use 85mm+ lens for ultimate intimacy."]
  },
  {
    id: "CPL-004",
    subject: "Couple",
    instruction: "Anchor your feet and lift with your knees—hold your partner at the hip and lock eyes for a beat; smile into each other's faces and keep the background shallow so the joyful mid-air moment reads spontaneous and secure.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-004.jpg",
    insights: ["Lifter must have secure footing first.", "Lifted partner should keep the core tight.", "Shutter speed 1/1000+ to freeze the peak."]
  },
  {
    id: "CPL-005",
    subject: "Couple",
    instruction: "Walk arm-in-arm along the grassy path; keep your torsos angled toward each other, chat naturally, and let smiles happen—I'll capture the candid smiles as you move.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-005.jpg",
    insights: ["Angled torsos suggest a 'private world'.", "Slow pace allows for more frames per stride.", "Watch for tree shadow dappling on faces."]
  },
  {
    id: "CPL-006",
    subject: "Couple",
    instruction: "Bring your foreheads together in a close, still moment; close your eyes, breathe in together, and hold that calm so the intimacy reads sincere against the white background.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-006.jpg",
    insights: ["Closed eyes help couples forget the camera.", "White backgrounds require careful skin tone exposure.", "Soften the jaw to avoid tense expressions."]
  },
  {
    id: "CPL-007",
    subject: "Couple",
    instruction: "Sit back-to-back outdoors; left person, look at the camera with relaxed shoulders; right person, close your eyes and lean in slightly so the shot reads mutual comfort.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-007.jpg",
    insights: ["Symbolizes being each other's strength.", "Vary head heights for better composition.", "Use natural vines or trees to frame the shot."]
  },
  {
    id: "CPL-008",
    subject: "Couple",
    instruction: "Raise one joined hand together and mirror each other's gesture; smile naturally and hold the pose while I warm the grasses with golden-hour light for a celebratory feel.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-008.jpg",
    insights: ["Joined hands act as the central anchor.", "Golden hour backlight is non-negotiable here.", "Focus on hopeful, sincere expressions."]
  },
  {
    id: "CPL-009",
    subject: "Couple",
    instruction: "I want you to walk away from me, shoulders touching slightly—move slowly and lean in toward each other so your silhouettes read togetherness against the trees.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-009.jpg",
    insights: ["Symbolic of the 'journey ahead'.", "Focus on clothing texture and environment.", "Keep silhouettes clearly defined."]
  },
  {
    id: "CPL-010",
    subject: "Couple",
    instruction: "Sit close on the bench and bring your heads nearer; relax your hands on your laps and smile gently—I'll wait for that softened, friendly moment.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-010.jpg",
    insights: ["Benches provide an everyday context.", "Closeness is key; heads should be near.", "Wait for the 'after-laugh' moment."]
  },
  {
    id: "CPL-011",
    subject: "Couple",
    instruction: "Wrap your arms around the front person's waist and keep the front partner's hands relaxed; show a soft smile and an open posture that sells closeness and protection.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-011.jpg",
    insights: ["The 'wrap around' signifies total security.", "Keep front hands soft and relaxed.", "Light evenly to highlight both faces."]
  },
  {
    id: "CPL-012",
    subject: "Couple",
    instruction: "Run hand-in-hand across the field—lean into the run, laugh at each other, and I'll freeze that forward step to emphasize joy and movement.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-012.jpg",
    insights: ["Running creates dynamic energy.", "Laughing at the 'silliness' gets real results.", "1/1250s shutter speed to freeze hair/grass."]
  },
  {
    id: "CPL-013",
    subject: "Couple",
    instruction: "Lean in close as if whispering; whisper something short, exhale, and keep the listener's expression neutral and engaged so the frame reads like a private exchange.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-013.jpg",
    insights: ["Whispering creates an exclusive world.", "Listener must react naturally to the whisper.", "Focus on the eyes of the person facing camera."]
  },
  {
    id: "CPL-014",
    subject: "Couple",
    instruction: "Take a small twirl while holding hands; let loose with real laughter and light footwork so the motion reads joyful and carefree against the natural backdrop.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-014.jpg",
    insights: ["Adds whimsy to the session.", "Rotate slowly to avoid dizziness.", "Capture the clothes flaring horizontally."]
  },
  {
    id: "CPL-015",
    subject: "Couple",
    instruction: "Walk slowly side-by-side with one arm draped over the other's shoulders; keep movements subtle so the late-afternoon light and calm posture read connected and warm.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-015.jpg",
    insights: ["Draped arms show comfortable intimacy.", "Late afternoon light is the most flattering.", "Sync strides for a balanced frame."]
  },
  {
    id: "CPL-016",
    subject: "Couple",
    instruction: "Sit close with foreheads touching and eyes closed; breathe slowly, relax your hands, and hold that stillness so the image reads tender and meditative.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-016.jpg",
    insights: ["Stillness is as powerful as movement.", "Relax the forehead to avoid frown lines.", "f/1.8 for a dreamy, shallow effect."]
  },
  {
    id: "CPL-017",
    subject: "Couple",
    instruction: "Hop into a secure piggyback with a quick safety check; carrier, keep your knees soft and squared; both of you, laugh and look at each other so the frame reads playful and stable.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-017.jpg",
    insights: ["High-energy personality shot.", "Safety first; carrier must be comfortable.", "Wait for the big 'mouth laugh'."]
  },
  {
    id: "CPL-018",
    subject: "Couple",
    instruction: "Stroll hand-in-hand smiling broadly; look at one another occasionally and walk slower than normal so I can catch candid laughs and relaxed posture.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-018.jpg",
    insights: ["Walk slower to help focus tracking.", "Connection is built through eye contact.", "Check background for distractions."]
  },
  {
    id: "CPL-019",
    subject: "Couple",
    instruction: "Come together with foreheads touching and soft smiles; I'll lower to eye level—breathe together and hold that intimate expression for me.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-019.jpg",
    insights: ["Low camera angle builds intimacy.", "Shared breath creates calm.", "Focus on light catching the eyes."]
  },
  {
    id: "CPL-020",
    subject: "Couple",
    instruction: "Quick playful piggyback—secure the hold, swing gently, and laugh; I'll capture the lifted feet and hair movement for an energetic, joyful frame.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CPL-020.jpg",
    insights: ["Hair movement adds dynamic energy.", "Lifted feet emphasize playfulness.", "Burst mode for peak laughter."]
  },

  // ==========================================
  // CREATIVE (20)
  // ==========================================
  {
    id: "CRE-001",
    subject: "Creative",
    instruction: "I want you to plant your feet hip-width, hands on your hips, soften your shoulders and lower your chin a touch—hold that stern, assertive gaze so the blazer and posture read powerful but controlled.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-001.jpg",
    insights: ["Hip-width stance is a grounded base.", "Lowering chin adds intensity to the gaze.", "Check blazer fit on the shoulders."]
  },
  {
    id: "CRE-002",
    subject: "Creative",
    instruction: "I want you to sit forward with elbows on your knees and hands clasped; relax your shoulders, keep your spine long, and give me a calm, approachable look that reads grounded and open.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-002.jpg",
    insights: ["Sitting forward builds immediate rapport.", "Clasped hands create a stable anchor.", "Keep the spine long to avoid slumping."]
  },
  {
    id: "CRE-003",
    subject: "Creative",
    instruction: "I want you in strict profile, hold the lapel gently with one hand, tuck your chin slightly and lengthen the neck so the jawline and blazer texture read clean and composed.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-003.jpg",
    insights: ["Profile highlights unique facial features.", "Holding lapel adds intentionality.", "Light the jaw and neck line sharply."]
  },
  {
    id: "CRE-004",
    subject: "Creative",
    instruction: "I want you to stand relaxed with hands in pockets and head tilted down a bit; keep the shoulders loose and the expression contemplative so the minimalist styling feels thoughtful and cool.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-004.jpg",
    insights: ["Keep hands/pockets loose to avoid bulk.", "Head tilt adds introspection.", "Minimalist styling needs clean backgrounds."]
  },
  {
    id: "CRE-005",
    subject: "Creative",
    instruction: "I want you to walk toward me with a steady stride, raise your right hand palm-out in a controlled gesture, and keep your gaze forward so the motion reads modern and decisive.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-005.jpg",
    insights: ["Hand gesture adds high-fashion element.", "Gaze must stay fixed and forward.", "1/500s+ shutter speed to freeze motion."]
  },
  {
    id: "CRE-006",
    subject: "Creative",
    instruction: "I want you to sit cross-legged on the stool, hands resting on your knees, look slightly to the side and breathe slowly so the pose reads balanced and quietly thoughtful.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-006.jpg",
    insights: ["Cross-legged on stool shows off posture.", "Looking aside adds mystery.", "Slow breathing settles the face."]
  },
  {
    id: "CRE-007",
    subject: "Creative",
    instruction: "I want you to square to the camera with hands on your hips, smile gently and keep your shoulders down so the patterned shirt and trousers read confident and joyful.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-007.jpg",
    insights: ["Square-on requires strong symmetry.", "Warm smile balances the bold pose.", "Check patterns for distracting vibrations."]
  },
  {
    id: "CRE-008",
    subject: "Creative",
    instruction: "I want you to walk toward me with the trench coat flowing, keep a long stride, chin level, and eyes focused forward so the movement feels powerful and fashion-forward.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-008.jpg",
    insights: ["Flowing coat adds dramatic fashion vibe.", "Longer strides look more statuesque.", "Low camera angle for a 'heroic' look."]
  },
  {
    id: "CRE-009",
    subject: "Creative",
    instruction: "I want you to sit on the backward chair, rest your forearms on the backrest, look toward the camera with a neutral face and keep your posture casual and relaxed.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-009.jpg",
    insights: ["Backward chair is a casual classic.", "Forearms on backrest are natural anchors.", "Eyes need intensity for neutral faces."]
  },
  {
    id: "CRE-010",
    subject: "Creative",
    instruction: "I want you to stand in profile, cross your arms, and lift your chin slightly while looking upward so the pose reads introspective and aspirational.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-010.jpg",
    insights: ["Profile highlights neck/clothing lines.", "Cross arms loosely for comfort.", "Looking up suggests vision."]
  },
  {
    id: "CRE-011",
    subject: "Creative",
    instruction: "I want you to stand by the railing, lean in slightly with one elbow, look off to the side and hold a soft, composed expression to pair fashion and architecture.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-011.jpg",
    insights: ["Railing adds vertical architectural lines.", "Leaning creates engagement with setting.", "Looking aside adds editorial mood."]
  },
  {
    id: "CRE-012",
    subject: "Creative",
    instruction: "I want you to close your eyes, bring your hands to your face and clasp gently, relax your shoulders and breathe so the moment reads quiet and contemplative.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-012.jpg",
    insights: ["Closed eyes help internal focus.", "Fingers near face must be soft.", "Maintain quiet/contemplative mood."]
  },
  {
    id: "CRE-013",
    subject: "Creative",
    instruction: "I want you to sit barefoot on the steps, tilt your head back and laugh naturally—let your hands rest loose on your knees so the scene reads candid and joyful.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-013.jpg",
    insights: ["Barefoot adds vulnerability/realness.", "Natural laugh via storytelling.", "Watch head tilt for chin line."]
  },
  {
    id: "CRE-014",
    subject: "Creative",
    instruction: "I want you to stand tall with the glasses in one hand, tilt your head a fraction and hold a poised, confident expression that reads professional and stylish.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-014.jpg",
    insights: ["Glasses act as intellectual prop.", "Head tilt adds approachable vision.", "Keep posture upright/confident."]
  },
  {
    id: "CRE-015",
    subject: "Creative",
    instruction: "I want you to walk down the street with your jacket slung over the shoulder, take purposeful strides, and keep your gaze ahead so the moment reads dynamic and urbane.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-015.jpg",
    insights: ["Slung jacket adds on-the-go energy.", "Purposeful strides look intentional.", "Fixed gaze for urban cool."]
  },
  {
    id: "CRE-016",
    subject: "Creative",
    instruction: "I want you to sit on the bench with hands up near your face in an expressive, joyful gesture; let your smile open naturally and relax into the outdoor light.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-016.jpg",
    insights: ["Gestures add joy and personality.", "Authentic open smile showing teeth.", "Soft natural light for warm vibe."]
  },
  {
    id: "CRE-017",
    subject: "Creative",
    instruction: "I want you to stand with the eyeglasses in one hand at your side, shift weight to one leg, and hold a slight head tilt so the outfit reads chic and assured.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-017.jpg",
    insights: ["Weight shift for natural silhouette.", "Eyeglasses anchor the hand position.", "Subtle head tilt for chic look."]
  },
  {
    id: "CRE-018",
    subject: "Creative",
    instruction: "I want you to walk confidently down the city street with the overcoat slung, shoulders relaxed and stride steady—hold that purposeful gaze so the frame reads cinematic.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-018.jpg",
    insights: ["Overcoat adds cinematic drama.", "Steady stride for urbane look.", "High-contrast city lighting."]
  },
  {
    id: "CRE-019",
    subject: "Creative",
    instruction: "I want you to sit on the bench, relax your posture, smile warmly and look at the camera so the park setting and your openness read welcoming and serene.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-019.jpg",
    insights: ["Bench adds approachable context.", "Warm smile for welcoming energy.", "Park setting for soft serenity."]
  },
  {
    id: "CRE-020",
    subject: "Creative",
    instruction: "I want you to stand with hands in pockets, toes slightly turned out, and look directly at me with a calm, neutral expression so the profile and sweater texture read strong.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/CRE-020.jpg",
    insights: ["Toes out for stable grounded stance.", "Neutral expression eye intensity.", "Highlight texture with side light."]
  },

  // ==========================================
  // LIFESTYLE (20)
  // ==========================================
  {
    id: "LIF-001",
    subject: "Lifestyle",
    instruction: "I want you to cradle the mug with both hands, lift it toward your face slightly, soften your smile and let your eyes light up as if the aroma just reached you; keep shoulders relaxed and the background warm and cozy.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-001.jpg",
    insights: ["Mug creates a sense of home.", "Authentic reaction lighting up eyes.", "Tungsten/sunset light for cozy feel."]
  },
  {
    id: "LIF-002",
    subject: "Lifestyle",
    instruction: "Sit back on the bench with a loose posture, place your hands casually on your thighs, give me a broad, natural smile and breathe into the moment so the sunlight and park behind you feel effortless.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-002.jpg",
    insights: ["Loose posture for effortless day vibe.", "Jokes for broad natural smiles.", "Back-sunlight for outdoor story."]
  },
  {
    id: "LIF-003",
    subject: "Lifestyle",
    instruction: "Walk toward me holding that paper bag, keep your shoulders relaxed and chin level, smile as if you just found something nice inside, and swing the bag gently so the motion reads casual and candid.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-003.jpg",
    insights: ["Paper bag is a daily errand prop.", "Level chin for natural walk look.", "Gentle swing adds rhythm/life."]
  },
  {
    id: "LIF-004",
    subject: "Lifestyle",
    instruction: "Sit with your hands clasped on the table in front of you, keep your spine long and shoulders soft, look directly into the lens with a calm, composed expression that reads approachable and steady.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-004.jpg",
    insights: ["Table adds coffee/work context.", "Clasped hands for visual anchor.", "Upright but relaxed posture."]
  },
  {
    id: "LIF-005",
    subject: "Lifestyle",
    instruction: "Lean forward a touch, rest your hands on your knees and let your smile open fully; keep your posture relaxed so the laugh reads vivid and genuine against the steps.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-005.jpg",
    insights: ["Leaning forward builds rapport.", "Hands on knees is youthful position.", "Wait for the big laugh reaction."]
  },
  {
    id: "LIF-006",
    subject: "Lifestyle",
    instruction: "Lift the glasses to your mouth in that thoughtful pose, soften your jaw and let your gaze drift into the distance for a beat—hold that reflective energy while I capture the quiet moment.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-006.jpg",
    insights: ["Glasses add to thoughtful mood.", "Drifting gaze for introspective feel.", "Light the eyes for quiet energy."]
  },
  {
    id: "LIF-007",
    subject: "Lifestyle",
    instruction: "Walk along the path with your phone in hand, keep a wide smile and let your arms move naturally; look up from the screen occasionally so the frame reads open and joyful.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-007.jpg",
    insights: ["Phone makes photo feel current.", "Connected story via gaze transition.", "Check for natural arm swing."]
  },
  {
    id: "LIF-008",
    subject: "Lifestyle",
    instruction: "Sit at the table and place your hands lightly on the surface, give me a warm smile and lean in a hair so the lighting and café setting feel intimate and friendly.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-008.jpg",
    insights: ["Café setting for friendly narrative.", "Engagement via leaning in.", "Over-shoulder warm lighting."]
  },
  {
    id: "LIF-009",
    subject: "Lifestyle",
    instruction: "Stand with the strap over the shoulder and grin broadly, keep your weight relaxed on one leg and swing the strap a hair to convey motion and casual energy as you walk.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-009.jpg",
    insights: ["Bag strap adds visual depth.", "Relaxed weight for casual silhouette.", "Light strap swing adds rhythm."]
  },
  {
    id: "LIF-010",
    subject: "Lifestyle",
    instruction: "Sit cross-legged right on the path, keep your back straight, rest hands on your knees, and smile warmly into the camera so the scene reads playful and serene in equal measure.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-010.jpg",
    insights: ["Cross-legged adds adventure vibe.", "Straight back for healthy presence.", "Outdoor path setting for lifestyle."]
  },
  {
    id: "LIF-011",
    subject: "Lifestyle",
    instruction: "Stand tall with the jacket slung over your shoulder, keep your face neutral-to-confident, and let your stride be deliberate—think of somewhere important you're headed so the posture reads purposeful.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-011.jpg",
    insights: ["Slung jacket for on-the-go energy.", "Purposeful posture for confidence.", "Fixed gaze ahead."]
  },
  {
    id: "LIF-012",
    subject: "Lifestyle",
    instruction: "Sit on the backward chair, rest your arms on the backrest and look toward me with a calm neutral face; keep your shoulders relaxed so the pose reads approachable and cool.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-012.jpg",
    insights: ["Approachable casual pose.", "Secure anchor via backrest.", "Eye intensity for neutral face."]
  },
  {
    id: "LIF-013",
    subject: "Lifestyle",
    instruction: "Stand in profile, cross your arms and tilt your chin up slightly while looking toward the sky—hold that aspirational, reflective pose for a clean silhouette.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-013.jpg",
    insights: ["Profile for feature highlighting.", "Loose arm cross for comfort.", "Looking up suggest vision."]
  },
  {
    id: "LIF-014",
    subject: "Lifestyle",
    instruction: "Lean on the railing with one elbow, turn your face slightly away and soften your eyes—hold that poised glance so the architecture and your outfit complement each other.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-014.jpg",
    insights: ["Architectural framing via railing.", "Casual engagement via elbow lean.", "Mystery via looking away."]
  },
  {
    id: "LIF-015",
    subject: "Lifestyle",
    instruction: "Close your eyes and bring your hands gently together by your face, breathe slowly and hold that quiet, meditative posture—keep the shoulders down and the expression serene.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-015.jpg",
    insights: ["Internal focus via closed eyes.", "Soft elegant hands near face.", "Meditative mood via breathing."]
  },
  {
    id: "LIF-016",
    subject: "Lifestyle",
    instruction: "Sit on the steps barefoot, tilt your head back and let a laugh come naturally; keep your hands loose on your knees so the moment reads candid and full of life.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-016.jpg",
    insights: ["Vulnerability via bare feet.", "Natural laugh via stories.", "Check chin line on head tilt."]
  },
  {
    id: "LIF-017",
    subject: "Lifestyle",
    instruction: "Stand with the glasses in your hand, tilt your head a fraction and hold a confident, composed expression so the look reads professional and stylish.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-017.jpg",
    insights: ["Style via glasses prop.", "Approachable vision via head tilt.", "Upright confident posture."]
  },
  {
    id: "LIF-018",
    subject: "Lifestyle",
    instruction: "Walk down the street with the coat over your shoulder, take purposeful strides and keep your chin level; imagine you're heading to a meeting—hold that cinematic, urbane energy.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-018.jpg",
    insights: ["Cinematic dynamic energy.", "Purposeful confidence via strides.", "High-contrast urban lighting."]
  },
  {
    id: "LIF-019",
    subject: "Lifestyle",
    instruction: "Sit on the bench and bring both hands up near your face with an open smile; let the natural light warm your expression and keep the movement easy and unforced.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-019.jpg",
    insights: ["Joy via expressive gestures.", "Authentic smile showing teeth.", "Warm natural lighting."]
  },
  {
    id: "LIF-020",
    subject: "Lifestyle",
    instruction: "Hold the glasses at your side, shift weight to one leg, and give a slight head tilt—keep the posture relaxed so the outfit reads chic and assured.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/LIF-020.jpg",
    insights: ["Subtle style via glasses.", "Casual chic via weight shift.", "Assured look via head tilt."]
  },

  // ==========================================
  // FITNESS (20)
  // ==========================================
  {
    id: "FIT-001",
    subject: "Fitness",
    instruction: "I want you to square your feet hip-width, flex both biceps and roll your shoulders back—keep your core tight, chest up, and hold that peak for two deep breaths so the light sculpts the muscle separation.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-001.jpg",
    insights: ["Intentional flex without face strain.", "Roll shoulders back for chest.", "Rim light highlights separation."]
  },
  {
    id: "FIT-002",
    subject: "Fitness",
    instruction: "Sit cross-legged on the mat, rest your hands palms-up on your knees, close your eyes and lengthen your spine; take a slow inhale and settle into stillness while I capture the calm in the soft window light.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-002.jpg",
    insights: ["Classic yoga stillness pose.", "Internal focus via closed eyes.", "Diffused lighting for serenity."]
  },
  {
    id: "FIT-003",
    subject: "Fitness",
    instruction: "Stand tall with a dumbbell in each hand, curl with controlled tempo and keep your elbows tucked to your sides; lock the top of the rep for a beat and soften your face so intensity reads focused, not strained.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-003.jpg",
    insights: ["Realism via controlled movement.", "Lock peak for bicep contrast.", "Soften face to avoid stress look."]
  },
  {
    id: "FIT-004",
    subject: "Fitness",
    instruction: "Sit cross-legged by the lake, press your palms into the knees in that mudra, lift through the crown of the head and relax your jaw—hold that peaceful count of three breaths while I frame the horizon behind you.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-004.jpg",
    insights: ["Nature serenity via lake setting.", "Upright posture via palm press.", "Relaxed jaw for peaceful expression."]
  },
  {
    id: "FIT-005",
    subject: "Fitness",
    instruction: "Plant both feet shoulder-width on the band, pull the handles up and out with intent—flare the shoulders slightly, keep a proud chest, and hold the contraction while I catch the band tension and upper-body engagement.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-005.jpg",
    insights: ["Realism via band movement.", "Highlight deltoids via shoulder flare.", "Visual tension via band stretch."]
  },
  {
    id: "FIT-006",
    subject: "Fitness",
    instruction: "Walk along the trail with long, steady strides; keep your shoulders relaxed, towel over one shoulder, water bottle in hand, and look out toward the view as if you're soaking it in—let your smile be easy and natural.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-006.jpg",
    insights: ["Outdoor wellness via trail props.", "Elegance via long strides.", "Cinematic narrative via looking away."]
  },
  {
    id: "FIT-007",
    subject: "Fitness",
    instruction: "Root into tree pose: balance on one leg, press the sole into the inner thigh, bring hands into prayer at your chest and soften your gaze—breathe steady so your stability and calm read through the frame.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-007.jpg",
    insights: ["Balance/core strength focus.", "Stability via rooting the leg.", "Calm via soft gaze and breath."]
  },
  {
    id: "FIT-008",
    subject: "Fitness",
    instruction: "Sit on the bench with the towel over your neck, relax your shoulders and smile—let that post-workout glow show through and drop your hands loosely between your knees for an open, satisfied vibe.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-008.jpg",
    insights: ["Satisfaction via post-workout rest.", "Context via towel prop.", "Authentic post-workout glow smile."]
  },
  {
    id: "FIT-009",
    subject: "Fitness",
    instruction: "Stand tall, extend one arm across your chest and gently pull with the other hand; relax the neck, keep your shoulders down, and hold the stretch long enough for the line of the shoulder to read clean in the light.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-009.jpg",
    insights: ["Flexibility via stretching pose.", "Clean lines via keeping shoulders down.", "Highlight shoulder with key light."]
  },
  {
    id: "FIT-010",
    subject: "Fitness",
    instruction: "Walk the path with a confident, mid-stride pace; keep your shoulders down, gym bag slung, smile lightly and look ahead as if greeting a new, energetic day—I'll freeze the forward motion.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-010.jpg",
    insights: ["Active narrative via gym bag.", "Energy via mid-stride pace.", "Burst mode for perfect leg position."]
  },
  {
    id: "FIT-011",
    subject: "Fitness",
    instruction: "Grip the kettlebell at chest level, stand tall with feet hips-width, keep elbows tucked, and breathe into the brace—hold the weight still so we capture the chest and arm tension.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-011.jpg",
    insights: ["Authentic tension via heavy weight.", "Emphasize arms via tucked elbows.", "Stability via core brace."]
  },
  {
    id: "FIT-012",
    subject: "Fitness",
    instruction: "Come to a steady cross-legged seat, bring your hands together at heart, close your eyes and relax the shoulders—hold that meditative posture so the room's calm reads through your expression.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-012.jpg",
    insights: ["Focus via steady seat.", "Centeredness via hands at heart.", "Presence via closed eyes."]
  },
  {
    id: "FIT-013",
    subject: "Fitness",
    instruction: "Stand with the jump rope in hand, soften the knees and hold the rope taut in front of you; look directly at me with a slight, focused smile—this is the poised moment before you start.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-013.jpg",
    insights: ["Energy via jump rope prop.", "Natural stance via soft knees.", "Readiness via focused smile."]
  },
  {
    id: "FIT-014",
    subject: "Fitness",
    instruction: "Jog slowly with the towel draped and water bottle visible; keep the stride natural and the shoulders relaxed, smile as you look toward the camera so the scene reads healthful and joyful.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-014.jpg",
    insights: ["Sharpness via slow jogging.", "Active narrative via props.", "Authenticity via natural smile."]
  },
  {
    id: "FIT-015",
    subject: "Fitness",
    instruction: "Hold the yoga block close to your chest, sit upright, soften your face and breathe; keep your shoulders away from your ears and hold that grounded, centered posture.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-015.jpg",
    insights: ["Anchor via yoga block.", "Strong posture via long neck.", "Centered mood via breathing."]
  },
  {
    id: "FIT-016",
    subject: "Fitness",
    instruction: "Sit on the gym floor with the towel around your neck and hands relaxed on your knees; lean forward a touch and smile like you just finished a great set—warm, satisfied, and candid.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-016.jpg",
    insights: ["Rest vibe via floor seating.", "Face framing via towel.", "Authentic glow via smile."]
  },
  {
    id: "FIT-017",
    subject: "Fitness",
    instruction: "Get into a light boxing stance with gloves up; soften your jaw, flare the ribs slightly and look through the gloves with focused intent—hold that tension so the shot reads combat-ready and composed.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-017.jpg",
    insights: ["Athletic energy via boxing stance.", "Core muscularity via rib flare.", "Face framing via gloves."]
  },
  {
    id: "FIT-018",
    subject: "Fitness",
    instruction: "Walk the park path with the yoga mat and rolled mat visible; keep your posture upright, smile naturally, and swing the bag so the motion reads active and upbeat.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-018.jpg",
    insights: ["Wellness narrative via yoga mat.", "Healthy look via upright posture.", "Rhythm via mat bag swing."]
  },
  {
    id: "FIT-019",
    subject: "Fitness",
    instruction: "Sit cross-legged on the mat, hands resting in mudra, lengthen your spine and close your eyes—breathe slowly and hold that serene count so the scene reads calm and centered.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-019.jpg",
    insights: ["Focus via cross-legged seat.", "Internal presence via closed eyes.", "Meditation mood via breathing."]
  },
  {
    id: "FIT-020",
    subject: "Fitness",
    instruction: "Stand tall holding the medicine ball at chest level, keep your core braced and shoulders down; hold the ball steady so the weight and texture read tactile and strong.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/FIT-020.jpg",
    insights: ["Muscle tension via heavy ball.", "Strong posture via core brace.", "Tactile feel via highlighted texture."]
  },

  // ==========================================
  // ARTISTIC (20)
  // ==========================================
  {
    id: "ART-001",
    subject: "Artistic",
    instruction: "Turn your head slightly left and keep your chin level—hold still so the warm backlight sculpts your profile cleanly and the silhouette reads calm and introspective.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-001.jpg",
    insights: ["Highlight unique features via clean profile.", "Introspective mood via backlight.", "Watch for stray hair breaking the line."]
  },
  {
    id: "ART-002",
    subject: "Artistic",
    instruction: "Sit with one arm resting on the chair and the other hand near your temple; tilt your head slightly and soften your gaze so the lighting catches the contours of your face and reads moody and reflective.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-002.jpg",
    insights: ["Moody vibe via Rembrandt lighting.", "Relaxed hands near face.", "Face depth via sculpted contours."]
  },
  {
    id: "ART-003",
    subject: "Artistic",
    instruction: "Rest your index finger along your temple and thumb under your chin; keep your eyes focused and jaw relaxed so the pose reads thoughtful and composed in the warm shadows.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-003.jpg",
    insights: ["Focus via thinking pose.", "Moody feel via warm shadows.", "Avoid tension in index finger."]
  },
  {
    id: "ART-004",
    subject: "Artistic",
    instruction: "Cover part of your face with your hand, leaving one eye visible through the fingers; hold a steady gaze and let the shadows wrap around your features so the image reads mysterious and intense.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-004.jpg",
    insights: ["Intrigue via partial face cover.", "Tack-sharp focus on the one eye.", "Dramatic wrap-around shadows."]
  },
  {
    id: "ART-005",
    subject: "Artistic",
    instruction: "Stand with one hand tucked into the coat pocket, turn your shoulders slightly, and hold a neutral expression so the lighting highlights the texture of the coat and your face reads cinematic and poised.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-005.jpg",
    insights: ["Natural silhouette via turned shoulders.", "Eye intensity for neutral face.", "Coat texture via directional light."]
  },
  {
    id: "ART-006",
    subject: "Artistic",
    instruction: "Sit on the stool, tilt your head back and close your eyes; keep your hands relaxed and let the shadows fall naturally so the pose reads introspective and emotionally open.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-006.jpg",
    insights: ["Vulnerability via head tilt.", "Internal focus via closed eyes.", "Moody artistic shadows."]
  },
  {
    id: "ART-007",
    subject: "Artistic",
    instruction: "Hold the circular mirror in front of your face, angle it so your reflection is centered and steady; keep your profile calm and let the lighting wrap around both views for a layered, contemplative effect.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-007.jpg",
    insights: ["Symbolic layer via mirror prop.", "Sharp focused reflection is key.", "Light both subject and reflection."]
  },
  {
    id: "ART-008",
    subject: "Artistic",
    instruction: "Walk forward with a slow, deliberate stride, let the coat flare slightly and keep your gaze ahead so the motion reads cinematic and self-assured.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-008.jpg",
    insights: ["Intentionality via slow stride.", "Dramatic flare via coat movement.", "Focus/mystery via fixed gaze."]
  },
  {
    id: "ART-009",
    subject: "Artistic",
    instruction: "Sit cross-legged and hold the wooden frame directly in front of your face; keep your expression neutral and centered so the composition reads like a living portrait.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-009.jpg",
    insights: ["Meta-layer via frame prop.", "Classic look via centered expression.", "Precision via frame centering."]
  },
  {
    id: "ART-010",
    subject: "Artistic",
    instruction: "Cross your arms and bow your head slightly, let your hair fall naturally and keep your posture soft so the lighting reads introspective and quietly emotional.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-010.jpg",
    insights: ["Quiet emotion via bowed head.", "Realism via natural hair fall.", "Soft posture for artistic read."]
  },
  {
    id: "ART-011",
    subject: "Artistic",
    instruction: "Lean on the railing with arms crossed, look off into the distance and hold a calm, steady expression so the scene reads contemplative and grounded in nature.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-011.jpg",
    insights: ["Horizontal anchor via railing.", "Private thought via looking aside.", "Serene mood via nature setting."]
  },
  {
    id: "ART-012",
    subject: "Artistic",
    instruction: "Hold the flower gently in both hands, tilt your head slightly down and soften your gaze so the moment reads tender and reflective in the warm shadows.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-012.jpg",
    insights: ["Organic beauty via flower prop.", "Reflection via downward head tilt.", "Artist mood via warm shadows."]
  },
  {
    id: "ART-013",
    subject: "Artistic",
    instruction: "Wrap your arms around your knees and tuck in slightly, keep your head low and let the lighting fall across your face so the pose reads vulnerable and introspective.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-013.jpg",
    insights: ["Safety/vulnerability via wrapped arms.", "Introspection via low head.", "Chiaroscuro lighting for drama."]
  },
  {
    id: "ART-014",
    subject: "Artistic",
    instruction: "Raise one arm above your head and let the other rest on your knee; keep the cloak draped and your posture still so the silhouette reads dramatic and enigmatic.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-014.jpg",
    insights: ["Verticality via raised arm.", "Timeless silhouette via cloak.", "Sharpness via postural stillness."]
  },
  {
    id: "ART-015",
    subject: "Artistic",
    instruction: "Walk slowly down the wet street with the umbrella angled slightly; keep your gaze soft and your stride steady so the scene reads cinematic and solitary.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-015.jpg",
    insights: ["Noir narrative via umbrella.", "Lost-in-thought gaze.", "Realism via steady stride."]
  },
  {
    id: "ART-016",
    subject: "Artistic",
    instruction: "Lean forward on the chair with arms crossed on the backrest, soften your face and hold a quiet gaze so the lighting reads intimate and grounded.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-016.jpg",
    insights: ["Psychological intimacy via lean.", "Approachable face via relaxed jaw.", "Soul-portrait via quiet gaze."]
  },
  {
    id: "ART-017",
    subject: "Artistic",
    instruction: "Cover your face with both hands, keep your elbows relaxed and let the shadows fall naturally so the moment reads intense and emotionally raw.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-017.jpg",
    insights: ["Raw intensity via face cover.", "Avoid skeletal look via relaxed elbows.", "Drama via hard lighting."]
  },
  {
    id: "ART-018",
    subject: "Artistic",
    instruction: "Lean against the wall with your gaze slightly off-camera, keep your posture relaxed and let the lighting sculpt your features so the mood reads contemplative and grounded.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-018.jpg",
    insights: ["Contemplative wall lean classic.", "Groundedness via relaxed posture.", "Feature sculpting via light."]
  },
  {
    id: "ART-019",
    subject: "Artistic",
    instruction: "Turn your head slightly and hold a steady gaze under the fedora; keep your posture upright and let the shadows define your jawline so the portrait reads classic and intense.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-019.jpg",
    insights: ["Classic intensity via fedora.", "Jawline definition via shadows.", "Strength via upright posture."]
  },
  {
    id: "ART-020",
    subject: "Artistic",
    instruction: "Hold the ceramic jug at chest level, keep your cloak wrapped and your posture still so the scene reads ritualistic and mysterious in the low light.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/ART-020.jpg",
    insights: ["Ritual mystery via jug prop.", "Flowy silhouette via cloak.", "Drama via low lighting."]
  },

  // ==========================================
  // BRANDING (20)
  // ==========================================
  {
    id: "BRD-001",
    subject: "Branding",
    instruction: "I want you to sit forward on the chair, lean into the frame and cross your arms softly—drop your shoulders, tuck your chin a touch, and hold a composed, confident look so the suit and jawline read strong but relaxed.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-001.jpg",
    insights: ["Rapport via leaning in.", "Confidence via arm cross.", "Jawline definition via chin tuck."]
  },
  {
    id: "BRD-002",
    subject: "Branding",
    instruction: "I want you to step toward the desk, place your forearms lightly on the surface and clasp your hands loosely; look into the lens and give me a warm, approachable half-smile while keeping your posture grounded.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-002.jpg",
    insights: ["Working status via desk prop.", "Transparency via loose hands.", "Approachability via half-smile."]
  },
  {
    id: "BRD-003",
    subject: "Branding",
    instruction: "I want you to pivot three-quarters away from me, reach up and adjust your tie with one hand, relax the opposite shoulder, lower your chin a hair, and hold a purposeful, controlled expression while I lock the tie line.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-003.jpg",
    insights: ["Candor via tie adjustment.", "Depth via three-quarter pivot.", "Vision via purposeful expression."]
  },
  {
    id: "BRD-004",
    subject: "Branding",
    instruction: "I want you to sit square with hands resting on the desk, keep your shoulders even and spine long, angle your torso a touch toward me, and hold a calm, open expression for a grounded portrait.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-004.jpg",
    insights: ["Stability via even shoulders.", "Authority via long spine.", "Trustworthiness via open expression."]
  },
  {
    id: "BRD-005",
    subject: "Branding",
    instruction: "I want you to take a small step forward as if offering a handshake—extend your right hand slightly, keep your palm relaxed and shoulder back, and give me a warm, inviting nod or small smile.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-005.jpg",
    insights: ["Welcoming via handshake gesture.", "Transparency via relaxed palm.", "Authority via inviting nod."]
  },
  {
    id: "BRD-006",
    subject: "Branding",
    instruction: "I want you to stand with hands on hips and weight on one leg; relax your jaw and shoulders, soften the stance so it reads assertive without rigidity, and hold steady for a commanding frame.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-006.jpg",
    insights: ["Leadership via assertive stance.", "Approachability via softness.", "Authority via commanding frame."]
  },
  {
    id: "BRD-007",
    subject: "Branding",
    instruction: "I want you to walk toward me with a purposeful, even stride carrying nothing in your hands; keep your shoulders relaxed, eyes forward, and take long, decisive steps so the motion reads composed.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-007.jpg",
    insights: ["Vision via purposeful stride.", "Confidence via relaxed shoulders.", "Authority via decisive steps."]
  },
  {
    id: "BRD-008",
    subject: "Branding",
    instruction: "I want you to stand center-frame and lift both hands slightly with palms open toward the camera; lower your shoulders, soften your smile, and present a genuine, candid energy.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-008.jpg",
    insights: ["Vulnerability via open palms.", "Warmth via softened smile.", "Trust via genuine energy."]
  },
  {
    id: "BRD-009",
    subject: "Branding",
    instruction: "I want you to put your hands in your pockets with thumbs out, shift weight to one hip, keep your shoulders loose, and give me a relaxed, confident expression so the silhouette reads clean.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-009.jpg",
    insights: ["Hand shape via thumbs out.", "Casual chic via weight shift.", "Professionalism via clean silhouette."]
  },
  {
    id: "BRD-010",
    subject: "Branding",
    instruction: "I want you to sit upright with hands clasped on the table, lean in a touch, hold a focused, intent expression, relax your shoulders, and keep eye contact so the portrait reads attentive.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-010.jpg",
    insights: ["Key attentive eye contact.", "Engagement via leaning in.", "Authority via focused intent."]
  },
  {
    id: "BRD-011",
    subject: "Branding",
    instruction: "I want you to lean forward with elbows on your knees and hands clasped; tilt your head up a fraction and hold a steady, thoughtful gaze that conveys seriousness without tension.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-011.jpg",
    insights: ["Authority via serious gaze.", "Vision via head tilt.", "Stability via clasped hands."]
  },
  {
    id: "BRD-012",
    subject: "Branding",
    instruction: "I want you to lean in slightly toward me, keep hands softly clasped on the table, and present a composed, attentive expression—make only small movements so the frame stays crisp.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-012.jpg",
    insights: ["Professionalism via crisp frame.", "Rapport via attentive expression.", "Precision via small movements."]
  },
  {
    id: "BRD-013",
    subject: "Branding",
    instruction: "I want you to adjust your tie or lapel with one hand, keep the other hand relaxed at your side, square your shoulders, lower the chin slightly, and give me a measured, confident look into the lens.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-013.jpg",
    insights: ["Candor via adjusting lapel.", "Strength via square shoulders.", "Jawline via lowered chin."]
  },
  {
    id: "BRD-014",
    subject: "Branding",
    instruction: "I want you to sit with a warm, controlled smile and hands relaxed on the table; angle your torso a touch toward me to read open and approachable while keeping the background simple.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-014.jpg",
    insights: ["Focus via simple background.", "Depth via angled torso.", "Rapport via warm smile."]
  },
  {
    id: "BRD-015",
    subject: "Branding",
    instruction: "I want you to stand with arms crossed but softened; tilt your chin up a hair, relax your shoulders, and hold a steady, professional expression that reads quiet confidence.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-015.jpg",
    insights: ["Vision via slight chin lift.", "Show fingers for warmth.", "Eye-level camera for authority."]
  },
  {
    id: "BRD-016",
    subject: "Branding",
    instruction: "I want you to sit at the desk and make a small, deliberate gesture with your pen while writing; keep your head angled toward the page, shoulders relaxed, and face focused to convey intentional work.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-016.jpg",
    insights: ["Narrative via pen prop.", "Shadow check on face.", "Authenticity via mid-stroke."]
  },
  {
    id: "BRD-017",
    subject: "Branding",
    instruction: "I want you to sit centered with hands visible and loosely clasped in front; lean in a touch, offer a genuine, relaxed smile, and let the portrait feel personable and professional.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-017.jpg",
    insights: ["Personable via centered look.", "Openness via loose clasp.", "Warmth via white balance."]
  },
  {
    id: "BRD-018",
    subject: "Branding",
    instruction: "I want you to walk past me with measured steps and your shoulder bag on; look ahead with calm focus, keep your shoulders down, and let the motion stay steady so I can capture purposeful movement.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-018.jpg",
    insights: ["Active professional via bag.", "Smoothness via heel-to-toe.", "Heroic look via low angle."]
  },
  {
    id: "BRD-019",
    subject: "Branding",
    instruction: "I want you to sit forward at the desk with the notebook visible, turn your head slightly toward me, and use small hand movements to show engagement while maintaining a composed presence.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-019.jpg",
    insights: ["Frame via notebook prop.", "Face focus via desk shadows.", "Engagement via hand moves."]
  },
  {
    id: "BRD-020",
    subject: "Branding",
    instruction: "I want you to sit with the paper and pen, angle your body toward the page, and hold a focused, deliberate expression—I'll time the shutter on a natural pause to show concentration.",
    link: "https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Posefolio%20Poses/BRD-020.jpg",
    insights: ["Concentration via profile.", "Timing via natural pause.", "Work ethic via focused look."]
  }
];

export const categories = [
  { id: 'business', name: 'Business', description: 'Professional headshots and corporate portraits', count: 20 },
  { id: 'senior', name: 'Senior', description: 'High school senior portraits and graduation photos', count: 20 },
  { id: 'couple', name: 'Couple', description: 'Romantic and engagement photography poses', count: 20 },
  { id: 'creative', name: 'Creative', description: 'Artistic and fashion-forward poses', count: 20 },
  { id: 'lifestyle', name: 'Lifestyle', description: 'Natural, everyday moment captures', count: 20 },
  { id: 'fitness', name: 'Fitness', description: 'Athletic and wellness photography', count: 20 },
  { id: 'artistic', name: 'Artistic', description: 'Dramatic and conceptual portraits', count: 20 },
  { id: 'branding', name: 'Branding', description: 'Personal branding and marketing photos', count: 20 }
];

export const getPosesByCategory = (category) => {
  const categoryMap = {
    'business': 'Business',
    'senior': 'Senior',
    'couple': 'Couple',
    'creative': 'Creative',
    'lifestyle': 'Lifestyle',
    'fitness': 'Fitness',
    'artistic': 'Artistic',
    'branding': 'Branding'
  };
  return posesData.filter(pose => pose.subject === categoryMap[category]);
};